<template>
  <div class="contbox">
    <div class="minaflexbox">
      <div class="flexrightbox">
        <div class="content_head">
          <div class="content_head_ico">
            <img src="@/assets/images/estorage/content_title_ico_blue.png" alt=""/>
          </div>
          <div class="content_head_title">
            货位管理
          </div>
          <div class="content_head_button">
            <div class="content_head_seek" v-if="permissionAddIs">
              <lk-button img="add.png" @click="storeroomDetails('',0)">新增</lk-button>
            </div>
          </div>
        </div>
        <div class="Notice_list">
          <el-table
              :data="granaryList"
              style="width: 100%"
          >
            <el-table-column prop="name" label="货位名称" fixed align="center"/>
            <el-table-column prop="status" label="货位状态" fixed align="center"/>
            <el-table-column prop="grainKind" label="粮食品种" align="center"/>
            <el-table-column prop="grainNature" label="粮食性质" align="center"/>
            <el-table-column prop="grainBelong" label="粮权所属" align="center"/>
            <el-table-column prop="designSize" label="设计容量(吨)" align="center"/>
            <el-table-column prop="actualSize" label="实际容量(吨)" align="center"/>
            <el-table-column prop="barName" label="绑定仓房" align="center"/>
            <el-table-column prop="useDate" label="启用日期" align="center"/>
            <el-table-column label="操作" align="center" fixed="right" width="120">
              <template slot-scope="scope">
                <el-button v-if="permissionFindIs" type="text" size="small" @click="storeroomDetails(scope.row.id,1)">详情
                </el-button>
                <el-button v-if="permissionUpdateIs" type="text" size="small" @click="storeroomDetails(scope.row.id,2)">编辑
                </el-button>
                <el-button v-if="permissionDelIs" type="text" size="small" style="color: red"
                           @click="holdStoreroomName=scope.row.name;storeroomDelete(scope.row.id)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging">
          <div class="block">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                layout="total, prev, pager, next"
                :total="totalQuantity">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {httpToken} from '@/utils/http'
import {mapMutations} from "vuex";
import qs from "qs";
import {getjudgePermission} from '@/utils/server/permission'
export default {
  name: 'Granary',
  data() {
    return {
      permissionAddIs:false,//新增权限
      permissionDelIs:false,//删除权限
      permissionUpdateIs:false,//修改权限
      permissionFindIs:false,//详情权限
      unit: JSON.parse(sessionStorage.getItem('user')).unitId,
      granaryList: [],
      currentPage: 1,
      totalQuantity: 0,
      holdStoreroomName: '',
    }
  },
  methods: {
    ...mapMutations('Manage', ['setGranaryState', 'setGranaryId']),
    ...mapMutations('Quality', ['setFreightspace']),
    // 获取货位数据
    getGranaryList(page, status) {
      let paramData = [{column: "unit", type: 'eq', value: JSON.parse(sessionStorage.getItem('user')).unitId},{ column: "create_date", type: "orderByDesc" },];
      this.currentPage = page
      httpToken({
        url: '/barn-info-son/list',
        method: 'post',
        data: qs.stringify({
          page: page,
          paramData: JSON.stringify(paramData),
          rows: 10,
        })
      }).then(res => {
        let Data = res.data.data
        // console.log(res.data.data)
        if (status === 'delete' && Data.pages < this.currentPage && Data.pages !== 0) {
          this.getGranaryList(Data.pages)
          return
        }
        const dataList = res.data.data.records
        if (dataList.length !== 0) {
          dataList.forEach((item) => {
            if (item.status === 0) {
              item.status = '完好'
            } else if (item.status === 1) {
              item.status = '损坏'
            }
            item.designSize=Math.round(item.designSize) / 1000
            item.actualSize=Math.round(item.actualSize) / 1000
          })
        }
        this.granaryList = dataList
        this.totalQuantity = res.data.data.total
      })
    },
    // 详情和编辑按键
    storeroomDetails(val, state) {
      this.setGranaryId(val);
      this.setGranaryState(state);
      this.$emit('update:comName', 'BasicsGranaryAdd')
    },
    // 删除一条货位信息
    storeroomDelete(id) {
      this.$confirm('确认删除 ' + this.holdStoreroomName + '，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        httpToken({
          url: '/barn-info-son/delOne',
          method: 'post',
          data: qs.stringify({
            id: id
          })
        }).then(res => {
          if (res.data.code === 200) {
            if(res.data.msg){
              this.$message({
                message: res.data.msg,
                type: 'success'
              })
            }
            this.getGranaryList(1, 'delete')
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      }).catch(() => {
      });
    },
    // 切换页数后每页数据显示
    handleCurrentChange(page) {
      this.getGranaryList(page)
    },
  },
  mounted() {
    if(this.$store.state.Quality.freightspace){
      let id=this.$store.state.Quality.freightspace
      this.setFreightspace('')
      this.storeroomDetails(id,2)
    }
    getjudgePermission('976').then(res=>{
      this.permissionAddIs=res
    })
    getjudgePermission('977').then(res=>{
      this.permissionDelIs=res
    })
    getjudgePermission('978').then(res=>{
      this.permissionUpdateIs=res
    })
    getjudgePermission('979').then(res=>{
      this.permissionFindIs=res
    })
    this.getGranaryList(1)
  }
}
</script>

<style lang="scss" scoped>
.contbox {
  width: 100%;
  height: 100%;
  background: #f4f6f8;
  overflow: auto;
  box-sizing: border-box;
  padding: 36px 34px 0;

  .contbox_box2 {
    width: 100%;
    padding: 30px 40px;
    //height: 75%;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0 3px 7px 0 rgba(91, 117, 148, 0.26);
  }

  .contbox_box1 {
    width: 100%;
    display: flex;
    height: 500px;
    margin-bottom: 32px;

    .imgshowbox {
      width: 45%;
      height: 100%;
      position: relative;
      margin-right: 36px;
      padding: 0;

      .pointList {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 99;

        li {
          display: inline;
          position: absolute;

          span {
            display: inline-block;
            padding: 3px;
            font-size: 12px;
            font-weight: 600;
            background-color: rgba(255, 255, 255, 0.6);
            border-radius: 50%;
            border: 1px solid red;
          }

          div {
            display: none;
            width: 150px;
            font-size: 16px;
            color: #ffffff;
            background-color: #00000075;
            line-height: 25px;
            position: absolute;
            left: -75px;
            bottom: -100px;
            padding: 10px 15px;
            border-radius: 5px;
            border: 1px solid red;
            z-index: 101;
          }
        }

        li:hover {
          cursor: pointer;

          div {
            display: inline-block;
          }
        }
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .eshowbox {
      flex: auto;
      height: 100%;
      background: #ffffff;
      box-shadow: 0 3px 7px 0 rgba(91, 117, 148, 0.26);
      display: flex;
      flex-direction: column;

      .echarts {
        flex: 1;
        height: 100%;
      }
    }

    .showbox {
      box-sizing: border-box;
      padding: 30px 36px 0;

      .headtitlebox {
        height: 18px;
        line-height: 18px;
        display: flex;

        img {
          width: 4px;
          height: 18px;
          margin-right: 11px;
        }

        span {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #383838;
        }
      }
    }
  }

  .minaflexbox {
    box-sizing: border-box;
    background-color: #ffffff;
    box-shadow: 0 3px 5px 0 #d5dade;
    padding: 0 40px 20px;
    display: flex;

    .flexleftbox {
      width: 300px;
      min-height: 600px;
      box-sizing: border-box;
      padding: 30px 40px 30px 0;
      border-right: 1px solid #e6e6e6;
      position: relative;

      .iconbutshowbox_treebox {
        margin-top: 10px;
        width: 100%;

        .iconbutshowbox_treeitemac {
          background: #f5f8ff;
        }

        .iconbutshowbox_treeitem {
          width: 100%;
          height: 50px;
          cursor: pointer;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          padding-left: 20px;
          padding-right: 10px;

          .titlebox {
            flex: auto;
            display: flex;
            align-items: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            ::v-deep .el-input__inner {
              border: 0;
              padding: 0 5%;
              background: transparent;
              border-radius: 0;
              width: 100%;
              border-bottom: 1px solid #000000;
            }
          }

          .iconimg {
            width: 22px;
            height: 26px;
            margin-right: 4px;
          }

          .morebox {
            cursor: pointer;
            margin-left: auto;
            width: 28px;
            height: 28px;
            background: #c2d4fd;
            border-radius: 4px;
            font-size: 36px;
            color: #376bf4;

            .iconimgbox {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;

              img {
                width: 18px;
                height: 4px;
              }
            }
          }
        }
      }

      .iconbutshowbox_headtitle {
        width: 100%;
        height: 66px;
        box-sizing: border-box;
        padding-left: 20px;
        display: flex;
        align-items: center;
        background: #f5f8ff;
      }

      .iconbut {
        cursor: pointer;
        width: 30px;
        height: 40px;
        box-sizing: border-box;
        position: absolute;
        top: 30px;
        right: -1px;
        background: #ffffff;
        border: 1px solid #e6e6e6;
        border-right: none;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 12px;
          height: 20px;
        }
      }

      .inputbox {
        box-sizing: border-box;
        padding-right: 10px;
        margin-bottom: 30px;
      }
    }
  }

  .flexrightbox_false {
    width: calc(100% - 30px) !important;
  }

  .flexrightbox {
    width: 100%;
    box-sizing: border-box;
    padding-top: 30px;
    background: #ffffff;
  }

  .iconbut_false {
    padding: 0 !important;
    width: 30px !important;

    img {
      transform: rotate(180deg);
    }
  }
}

.content_head {
  display: flex;
  font-size: 18px;
  margin-bottom: 50px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    margin: auto 10px auto 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    margin: auto 0;
  }

  .content_head_button {
    max-width: 70%;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-left: auto;

    ::v-deep .el-button {
      padding: 10px 42px;
      font-size: 16px;

      span {
        font-size: 14px;
      }
    }

    .content_head_seek {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }

      .el-button {
        padding: 10px;
      }
    }
  }
}

.Notice_list {
  ::v-deep .el-table th {
    background-color: #F5F8FF;
  }

  ::v-deep .el-table thead {
    color: #000000
  }
}

.paging {
  margin-top: 20px;

  ::v-deep .el-pagination {
    text-align: right;
  }
}

.dialog_content {
  //margin-bottom: 30px;

  p {
    margin-bottom: 10px;
  }

  .dialog_content_c {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    span {
      text-align: right;
      width: 30%;
      padding-right: 10px;
    }

    .el-select {
      width: 60%;
      margin: auto 0;
    }

    .el-input {
      width: 60%;
      margin: auto 0;
    }

    .el-textarea {
      width: 60%;
      margin: auto 0;
    }
  }
}
</style>

